<template>
  <div>
    <template v-if="isLoading">
      <md-table>
        <md-table-row>
          <md-table-cell colspan="4">
            <div class="spinner"></div> 
          </md-table-cell>
        </md-table-row>
      </md-table>
    </template>
    <template v-else>
      <div v-if="(this.expandable === true)"> 
        <md-table v-model="activeTaskList" md-sort="startTime" md-sort-order="asc" md-card md-fixed-header>
          <!-- Table header -->
          <!-- <md-table-toolbar class="">
            <h1 class="md-title">Completed Task List</h1>
          </md-table-toolbar> -->
            <md-table-row v-if="activeTaskList.length === 0">
              <md-table-cell colspan="4">
                <md-table-empty-state md-label="No processes found" :md-description="'No processes found in task List '"></md-table-empty-state>
              </md-table-cell>
            </md-table-row>
            <md-table-row  v-else v-for="item in activeTaskList" :key="item._id"  md-selectable="single"
              :class="{ 'selected-row': item === selectedActive }" @click.native="onSelect(item)" :style="{ backgroundColor: item.completed ? 'hsl(141, 74%, 66%)' : 'transparent' }" >
              <md-table-cell md-label="Workflow Name" 
              class="workflowwidth" md-sort-by="name">
              {{ item.name }} </md-table-cell>
              <md-table-cell md-label="Company"
              class="otherColumns" md-sort-by="mail">
              {{ item.OrgName }} </md-table-cell>
              <md-table-cell md-label="Assignee"
              class="otherColumns" md-sort-by="mail">
              {{ item.mail }} </md-table-cell>
              <md-table-cell md-label="Start Date"
              class="otherColumns" md-sort-by="create">
              {{ item.create }} </md-table-cell>
              <md-table-cell md-label="End Date"
              class="otherColumns" md-sort-by="completed">
              {{ item.completed }} </md-table-cell>
            </md-table-row>
        </md-table>
      </div>
      <div v-else> 
        <md-table v-model="completedTaskList" md-sort="startTime" md-sort-order="asc" md-card md-fixed-header>
            <md-table-row v-if="completedTaskList.length === 0">
              <md-table-cell colspan="4">
                <md-table-empty-state md-label="No processes found" :md-description="'No processes found in task List '"></md-table-empty-state>
              </md-table-cell>
            </md-table-row>
            <md-table-row  v-else v-for="item in completedTaskList" :key="item._id" >
              <md-table-cell md-label="Workflow Name"
              class="workflowwidth" md-sort-by="name">
              {{ item.name }} </md-table-cell>
              <md-table-cell md-label="Company"
              class="otherColumns" md-sort-by="mail">
              {{ item.OrgName }} </md-table-cell>
              <md-table-cell md-label="Assignee"
              class="otherColumns" md-sort-by="mail">
              {{ item.mail }} </md-table-cell>
              <md-table-cell md-label="Start Date"
              class="otherColumns" md-sort-by="create">
              {{ item.create }} </md-table-cell>
              <md-table-cell md-label="End Date"
              class="otherColumns" md-sort-by="completed">
              {{ item.completed }} </md-table-cell>
            </md-table-row>
        </md-table>
      </div>
    </template>
    <div class="viewResources" v-if="!isLoading">
      <md-button v-if="!requestVisible" class="md-primary md-raised " @click="showRequestData">View Request Details</md-button>
      <md-button v-if="requestVisible" class="md-raised" style="background-color:grey;color:white;" @click="showRequestData">close</md-button>


      <template v-if="requestVisible">
              <div class="objectContent">
              <div>
                <table>
                  <thead style="border-bottom:1px solid grey">
                    <tr><th class="headerStyle">Request Details</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(value, key) in processVariables" :key="key">
                      <td class="keyStyles">{{ key }}</td> <td class="valueStyles">{{ value }}</td>
                    </tr>
                  </tbody>
                </table>
              </div></div>
            </template>

    </div>
    <BModal :id="ActiveTaskModalId" :ref="ActiveTaskModalId" size="md" >
      <FRRelationshipViewActiveTask :itemSelected=selectedActive @data-to-parent="handleDataFromChild" ></FRRelationshipViewActiveTask>
      <!-- have the modal footer to keep blank footer -->
      <div slot="modal-footer" class="w-100">
       
      </div>
    </BModal>
  </div>
</template>

<script>
import { generateIdmApi } from '../../../api/BaseApi';
import FrIcon from '@forgerock/platform-shared/src/components/Icon';
import cloneDeep from 'lodash/cloneDeep';
import RelationshipViewActiveTask from '@forgerock/platform-shared/src/components/resource/ViewRelationshipActiveTask';
import axios from 'axios';
export default {
  name: 'RelationshipViewEngineModel',
  components: {
    FrIcon,
    FRRelationshipViewActiveTask: RelationshipViewActiveTask
  },
  props: {
    itemSelected: {
      type: Object,
      required: true,
    },
    expandable: {
      type: Boolean,
      required: true,
    }

  },
  data() {
    return {
      realmIsEA : (localStorage.getItem('originalLoginRealm') == '/EA' || localStorage.getItem('originalLoginRealm') == 'EA' || localStorage.getItem('originalLoginRealm') == 'EA/') ? true : false,
      activeTaskList: [],
      completedTaskList: [],
      individualPendingRequests: [],
      searched: [],
      isOpenidmAdmin: this.$store.state.UserStore.adminUser,
      isLoading: false,
      selectedActive: null,
      processVariables:[],
      requestVisible:false,
      ActiveTaskModalId: `show_completed_task_list`
    }
  },
  mounted() {
    console.log("this is what i want to see. ==================> : ", this.itemSelected, this.expandable)
    this.getTasksListData();
  },
  methods: {
    async handleDataFromChild(data){
      console.log("are you seeing data from parent on assignment", data)
      if(data){
        this.isLoading = true;
        await this.getTasksListData();
        this.isLoading = false;
        this.$refs[this.ActiveTaskModalId].hide()
      }
    },
    showRequestData(){
      this.requestVisible= !this.requestVisible
    },
    async getTasksListData() {

      //console.log("====================> realm is  EA",this.realmIsEA)
      var tableData = []
      this.isLoading = true;
      if (this.expandable === true) {
        // generateIdmApi().get('/workflow/processinstance/' + this.itemSelected.active_id).then((response) => {
        //   this.activeTaskList = response.data
        //   console.log("values", this.activeTaskList)
        // })
        try {
          
          if (this.realmIsEA){
            tableData = await axios.get(`${process.env.VUE_APP_IDM_URL}/endpoint/eaActiveCompletedTaskList?taskId=` + this.itemSelected.proc_inst_id_ + `&completed=false`);
          }else {
            tableData = await axios.get(`${process.env.VUE_APP_IDM_URL}/endpoint/activeCompletedTaskList?taskId=` + this.itemSelected.proc_inst_id_ + `&completed=false`);
          }
        } catch (error) {
          console.error(error);
        }
        this.activeTaskList = Object.values(tableData.data.data)
        this.processVariables = tableData.data.processVariables
        console.log(" ==>  activeTask List",this.activeTaskList,tableData)
      } else if (this.expandable === false) {
        try {
          if (this.realmIsEA){
            tableData = await axios.get(`${process.env.VUE_APP_IDM_URL}/endpoint/eaActiveCompletedTaskList?taskId=` + this.itemSelected.proc_inst_id_ + `&completed=true`);
          }else {
            tableData = await axios.get(`${process.env.VUE_APP_IDM_URL}/endpoint/activeCompletedTaskList?taskId=` + this.itemSelected.proc_inst_id_ + `&completed=true`);
          }
        } catch (error) {
          console.error(error);
        }
        this.completedTaskList = Object.values(tableData.data.data)
        this.processVariables = tableData.data.processVariables
        console.log(" ==>  completedTask List",this.completedTaskList)
      }
      this.isLoading=false;
    },
    onSelect(item) {
      if(!item.completed && this.isOpenidmAdmin){
        this.selectedActive = item;
        this.$refs[this.ActiveTaskModalId].show()
        console.log("isOpenIdmAdmin ",this.isOpenidmAdmin)
      } else {
        this.selectedActive = item;
      }
    },
  }
}
</script>

<style>
.objectContent{
  background-color: #99aeb5;
  border-radius: 10px;
  width:700px;
  display: flex;
  flex-direction: row;
  padding:25px;
  margin-top: 25px;
}

.keyStyles {
  font-weight:bold;
  padding: 5px;
  text-transform:capitalize;
  color: #000000;
}
.valueStyles {
  padding: 5px;
  max-width:465px;
  overflow: hidden;
  word-wrap: break-word;
  color: #000000;
}

.headerStyle{
  line-height: 25px;
  font-size: 19px;
  padding-top: 5px;
  padding-left: 5px;
  padding-right: 5px;
  padding-bottom: 15px;
  color: #000000;
}


.spinner {
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-left-color: #1a73e8;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  animation: spin 1s infinite linear;
  margin: 0 auto;
}
@keyframes spin {
  0% { transform: rotate(0deg);}
  100% {transform: rotate(360deg);}
}

.resourceNameValue {
  width: 50%;
  min-height: 24px;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  display: flex;
  align-items: center;
  color: #000000;
}

.roleValue {
  width: 50%;
  min-height: 24px;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  display: flex;
  align-items: center;
  color: #000000;
}

.border {
  border: 1px solid #F7F7F7;
}

.headerRoles {
  display: flex;
  height: 48px;
  align-items: center;
  gap: 10px;
}

.headerboxlable1 {
  width: 50%;
  height: 24px;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  padding-left: 24px;
  display: flex;
  align-items: center;
  color: #000000;
  flex: none;
  order: 0;
  flex-grow: 0;
}

.headerboxlable23 {
  width: 50%;
  height: 24px;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  display: flex;
  align-items: center;
  color: #000000;
  flex: none;
  order: 1;
  flex-grow: 0;
}

.sideheader {
  width: 100%;
  height: 22px;
  font-size: 12px;
  line-height: 18px;
  color: #5B6376;
  font-weight: 600;
  display: flex;
  align-items: center;
  flex: none;
  order: 0;
  flex-grow: 0;
}

.sideHeaderContainer {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 6px 24px;
  width: 100%;
  height: 32px;
  background: #F7F7F7;
  border: 1px solid #E3E5E8;
  text-transform: uppercase;
}

.contentToDisplay {
  display: flex;
  flex-direction: column;

}
.selected-row {
  background-color: lightblue;
}

.valueColor {
  color: #00A9E0
}

.viewResources{
  display: flex;
  flex-direction:column;
  justify-content: center;
  align-items: center;
  gap:20px;
  margin-top: 20px;
}

.otherColumns .md-table-cell-container{
  width: 200px !important;
  overflow: hidden;
  word-wrap: break-word;
}

.workflowwidth .md-table-cell-container{
  width: 300px !important;
  overflow: hidden;
  word-wrap: break-word;
}

</style>